import { render, staticRenderFns } from "./segment.vue?vue&type=template&id=3015e0db&"
import script from "./segment.vue?vue&type=script&lang=js&"
export * from "./segment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports